import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { clipping_model_editable, clipping_on } from '@features/clipping';
import place_svg from '../../../assets/img/SVG_icons/Top/editing_model/set_vertex_coordinates.svg';
import { img } from '@phi/components';
import { display_setVertexXYZ_modal } from '@frontend/ui_display';
import PlaceTooltip from './PlaceTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const PlaceIcon = place_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Place';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || this.state.rigid_move_manipulator
                || (
                    clipping_on.value
                    && !clipping_model_editable.value
                )
                || this.state.selected_vertices_count === 0;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                display_setVertexXYZ_modal();
        },
    },

    render() {
        return h(BarButton, {
            id: 'set-vertex-xyz-button',
            wrapperId: 'set-vertex-xyz-wrapper',
            tippy: 'left',
            onClick: this.onClick,
            active: false,
            selected: this.state.tut_stage === 5,
            disabled: this.disabled,
            help: 'set_vertex_xyz',
        }, {
            label: () => 'Place',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(place_svg, this.alt),
            tooltip: PlaceTooltip,
        });
    },
});
